import { useNavigate } from "react-router-dom";
import { AuthLoginForm } from "./AuthLoginForm";
import { AzureSignInButton } from "./AzureSignInButton";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

type Props = {
  loading: boolean;
  signIn: (email: string, password: string) => Promise<any>;
  signUp: (email: string, password: string, fullName: string) => Promise<any>;
};

export const AuthTabs = ({ loading, signIn, signUp }: Props) => {
  const navigate = useNavigate();

  return (
    <Card className="w-full max-w-md border-2 border-amber-200 bg-white/95 backdrop-blur-sm shadow-2xl shadow-amber-200/20">
      <CardContent className="p-6 sm:p-8">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-foreground">Bem-vindo ao Aroan</h1>
          <p className="text-muted-foreground mt-1">Entre na sua conta ou crie uma nova</p>
        </div>

        <AuthLoginForm loading={loading} signIn={signIn} />
        
        <div className="relative my-6">
          <Separator />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="bg-white px-4 text-sm text-muted-foreground">ou</span>
          </div>
        </div>

        <AzureSignInButton loading={loading} />

        <div className="relative my-6">
          <Separator />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="bg-white px-4 text-sm text-muted-foreground">novo por aqui?</span>
          </div>
        </div>

        <Button variant="outline" className="w-full" onClick={() => navigate("/register")}>
          Criar Nova Conta Empresarial
        </Button>
      </CardContent>
    </Card>
  );
};